// extracted by mini-css-extract-plugin
module.exports = {"colorBlock":"index-module--color-block--1aUh_","colorPickerOverlay":"index-module--color-picker-overlay--3cwNW"};